<template>
  <div class="pageTreeViewComponent">
    <div class="tree-menu">

      <div class="label-wrapper cursor-class">
        <div :style="indent">
          <b-form-checkbox @input="checkPageBox()">
            📝
            <span @click="$refs.pageEditBtn.showActionModal()" class="ml-2 title-page-class">
              {{ node.name }}
              <b-badge v-if="node.is_modif_annuelle" pill variant="warning"><v-icon scale="0.6" name="sync"/></b-badge>
              <b-badge v-if="node.force_selenium" variant="info"><v-icon scale="1" name="tv"/></b-badge>
              <b-badge v-if="node.is_timeout" class="ml-2" pill variant="warning"><v-icon scale="0.7" name="clock"/> Timeout</b-badge>
              <b-badge v-if="node.is_bugged && !node.is_timeout" class="ml-2" pill variant="danger">Bug</b-badge>
              <b-badge v-if="node.is_bugged && !node.is_timeout" class="ml-2" pill variant="danger">{{node.last_status}}</b-badge>
            </span>
          </b-form-checkbox>
          <pageEditButtonComponent
            ref="pageEditBtn"
            :token="token"
            :node="node"
            :show-button="false"
            v-on:reset-folders-pages="$emit('reset-folders-pages')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageEditButtonComponent from "@/components/page/pageEditButtonComponent"

export default {
  name: 'pageTreeViewComponent',
  props: {
    depth: Number,
    node: Object,
    token: String
  },
  components: {
    pageEditButtonComponent
  },
  computed: {
    indent() {
      return { transform: `translate(${this.depth * 50}px)` }
    },
  },
  methods: {
    checkPageBox () {
      this.$emit('check-page-box', this.node.id)
    },
  }
}
</script>

<style>
.cursor-class {
  cursor: pointer;
}

.title-page-class:hover {
  font-weight: 600;
}
</style>
